export const focusOnElement = (elementId: string) => {
    requestAnimationFrame(() => {
        const elementToFocusOn = document.querySelector<HTMLButtonElement>(`[id="${elementId}"]`)

        if (elementToFocusOn) {
            elementToFocusOn.setAttribute('tabindex', '0')
            elementToFocusOn.focus()
        }
    })
}
